import React from 'react'
import Pagination from '../Layout/Pagination';
import UseAllCategory from '../../CustomHooks/Category/UseAllCategory';
import AdminAllCategoryConatiner from './AdminAllCategoryConatiner';

const AdminAllCategoryComp = () => {

  const [searchValue, handleChangeSearchValue, allCategories, loading, pageCount, onPress] = UseAllCategory()

  return (
    <>
      <AdminAllCategoryConatiner AllCategories={allCategories} loading={loading} searchValue={searchValue} handleChangeSearchValue={handleChangeSearchValue}/>
      {pageCount > 1 ? (<Pagination pageCount={pageCount} onPress={onPress} />) : null}
    </>
  );
};

export default AdminAllCategoryComp
